import Box from '@mui/material/Box';
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getHeaderProjects } from '../../../modules/project';
import { listAllUsers } from '../../../modules/users';
import ProjectDropDown from './ProjectDropDown';
import UserDropDown from './UserDropDown';
import { useAccess } from '../../../hooks/useAccess';
import { useUserAccess } from '../../../hooks/useRole';
import QUERY_KEYS from '../../../query/queryKeys';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Guard } from '../../../features/Guard';

const NavbarDropdowns = () => {
  const navigate = useNavigate();
  const { canSeeAllDefects, isLoading } = useUserAccess();

  const { canAccess, activeRole } = useAccess();
  const { data: projectList = [], refetch: fetchProjectList } = useQuery({
    queryKey: QUERY_KEYS.project.headerProjects(),
    queryFn: getHeaderProjects,
    enabled: !!activeRole && activeRole !== 'super-admin',
  });

  const { data: userData, refetch: fetchUserData } = useQuery({
    queryKey: QUERY_KEYS.users.headerUsers({ perPage: 5 }),
    queryFn: () => listAllUsers(5),
    enabled: canAccess('ViewUsers'),
  });

  const users = userData?.users || [];

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
      {activeRole !== 'super-admin' && (
        <ProjectDropDown
          projectList={projectList}
          fetchprojectList={fetchProjectList}
        />
      )}
      <Guard policy="ViewUsers">
        <UserDropDown users={users} fetchUserData={fetchUserData} />
      </Guard>
      {!isLoading && canSeeAllDefects &&
        <Button
          id="reports"
          variant="text"
          disableElevation
          sx={{ color: 'var(--primary-color)', fontWeight: 'bold', ml: 5 }}
          onClick={() => handleNavigate('/reports')}
        >
          Reports
        </Button>
      }
    </Box>
  );
};

export default NavbarDropdowns;
